import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { HeaderDetailsItem } from '../../models/componentInterfaces';

@Component({
  selector: 'app-square-details',
  templateUrl: './square-details.component.html',
  styleUrls: ['./square-details.component.scss']
})
export class SquareDetailsComponent implements OnInit {

  detailsTitle: string;
  collapse: boolean = false;
  headerItems: HeaderDetailsItem[] = [];
  showHeader: boolean = false;
  @Output() onItemClick: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  itemClicked(item: HeaderDetailsItem) {
    if (item.isLink) {
      this.onItemClick.emit(item);
    }
  }

}
